import { ActionName, ServerActionName } from 'api/endpoints/action-names';
import {
  OnAddSave,
  OnEditSave,
} from 'components/UIComponents/EntityTable/EntityTable.types';
import {
  apiClaimActionNames,
  toActionName,
} from 'pages/SettingsPage/api/apiClaimsActionNames';
import { useClaimResolutionTypeContext } from 'providers/ClaimResolutionTypeProvider';
import { useCallback, useMemo } from 'react';
import { FetchStatus } from 'types/fetch-status.types';

export type ActionNameData = {
  data: ActionName[];
  status: FetchStatus;
};

export function useClaimActionNames() {
  const { actionNames: actionNames_orig, refreshActionNames } =
    useClaimResolutionTypeContext();

  const actionNames = useMemo(
    () => actionNames_orig.filter(filterExistingActionNames).map(toActionName) ?? [],
    [actionNames_orig],
  );

  const onEditSave: OnEditSave<ActionName> = useCallback(
    async (formValues, item: ActionName) => {
      const params = {
        id: item.id,
        actionName: (formValues.name as string) || item.name,
        actionSubStatusId: +formValues.substatusId || item.substatusId,
        hearingDate: (formValues.hearingDate as string) || item.hearingDate,
      };

      const result = await apiClaimActionNames.put(params);
      refreshActionNames();

      return result;
    },
    [refreshActionNames],
  );

  const onAddSave: OnAddSave<ActionName> = useCallback(
    async (formValues) => {
      const params = {
        actionName: formValues.name as string,
        actionSubStatusId: +formValues.substatusId,
        hearingDate: formValues.hearingDate as string,
      };

      const result = await apiClaimActionNames.post(params);
      if (result.type === FetchStatus.Done) {
        refreshActionNames();
      }

      return result;
    },
    [refreshActionNames],
  );

  return {
    onEditSave,
    onAddSave,
    actionNames,
  };
}

export const filterExistingActionNames = (actionName: ServerActionName) =>
  actionName.id > 0;
